import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    archName: '库表地图',
    archUrl: '/ProjectDbMap',
    codeProp: 'dbUserCode',
    detailIdProp: 'dbId',
    detailUrl: '/DbDetail',
    listUrl: '/DbList',
    mapProp: 'dbMap',
    name: '数据库',
    textProp: 'dbName',
    type: 'DB',
}
